import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import modalConsts from 'Consts/ModalNames';
import { useLocation } from 'react-router';
import ActionItemList from 'Components/UI/ActionItems/ActionItemList';
import useCollection from 'Hooks/useCollection';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { openModal } from 'Helpers/ModalHelper';
import { QueryVal, removeQuery } from 'Helpers/Query';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    // Allow the drop-shadow to be visible.
    // The root of the goals container has overflowY: 'auto' so that it can take over scrolling, which means that this box-shadow isn't visible by default
    marginBottom: theme.spacing(1),
  },
  title: {},
  todoTopRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  addTodoButton: {
    color: theme.palette.facet.accentGreen,
    fontSize: theme.typography.h3.fontSize,
  },
});

function GoalTodoList({ goal, classes, className }) {
  const { collection, setCollection } = useCollection();
  const location = useLocation();
  const { rootNodeProps, logResourceEvent } = useEventTrackingLogEvent({ nodeName: 'Goal Todo List' });

  const getTodos = async () => {
    if (goal.relationship('actionItems')) {
      try {
        const todos = await goal.relationship('actionItems').link('related').Get({
          params: {
            hidden: 'false',
            sort: 'completedAt',
          },
        });
        setCollection(todos);
      } catch (e) {
        displayErrorMessage(e, 'Could not fetch goal todos');
      }
    }
  };

  const handleClickAddTodo = () => {
    logResourceEvent('Client Goals Page: Clicked Add To Do on Goal', goal);
    openModal(
      modalConsts.goalActionItemModal,
    );
  };

  useEffect(() => {
    getTodos();
  }, [goal.id()]);

  useEffect(() => {
    if (QueryVal('refresh') === 'goalActionItem') {
      removeQuery('refresh');
      getTodos();
    }
  }, [location.search]);

  return (
    <div {...rootNodeProps} className={classNames(classes.root, className)}>
      <div className={classes.todoTopRow}>
        <Typography
          className={classes.title}
          color="primary"
          variant="h1"
        >
          To Do
        </Typography>
        <Button
          color="secondary"
          size="large"
          variant="text"
          onClick={handleClickAddTodo}
          endIcon={<AddCircleIcon color="secondary" />}
        >
          {'Add To Do'}
        </Button>
      </div>
      <div>
        {collection && <ActionItemList actionItemCollection={collection} refreshActionItems={getTodos} replaceActionItem={getTodos} useGoalModal />}
      </div>
    </div>
  );
}

GoalTodoList.defaultProps = {
  className: '',
};

GoalTodoList.propTypes = {
  goal: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles)(GoalTodoList);
